module.exports = require('./helpers/bundle-url').getBundleURL('9OpHv') + "logo.c51670a8.svg";